export default {
  namespaced: true,
  state: {
    items: {}
  },
  getters: {
    items: state => state.items,
    // season({ actions }, { season }) {
    //   return findEpisodes({ episode, season });
    // }
  },
  mutations: {},
  actions: {
    createEpisode: ({ dispatch }, item) => dispatch('createItem', { resource: 'episodes', item }, { root: true }),
    fetchEpisode: ({ dispatch }, { id }) => dispatch('fetchItem', { resource: 'episodes', id }, { root: true }),
    fetchEpisodes: ({ dispatch }, { ids }) => dispatch('fetchItems', { resource: 'episodes', ids }, { root: true }),
    findEpisode: ({ dispatch }, query) => dispatch('findItem', { resource: 'episodes', query }, { root: true }),
    findEpisodes: ({ dispatch }, { query, order, limit }) => dispatch('findItems', {
      resource: 'episodes',
      query,
      order,
      limit
    }, { root: true }),
    updateEpisode: ({ dispatch }, { id, data }) => dispatch('updateItem', { resource: 'episodes', id, data }, { root: true }),
  }
};
